import React from 'react'
import { Box, Typography, Stack, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatDiffValue } from '../utils/formatters'
import { getActionLabel, getAttributeLabel } from '../utils/historyHelpers'

interface DiffItem {
  attribute: string
  old_value: string
  new_value: string
}

interface HistoryItemDiffProps {
  diff: DiffItem
  action: string
  routingKey: string
  isLast: boolean
}

const HistoryItemDiff: React.FC<HistoryItemDiffProps> = ({ 
  diff, 
  action, 
  routingKey, 
  isLast 
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Box
      sx={{
        pb: isLast ? 0 : 2,
        pl: 2,
        position: 'relative',
      }}
    >
      <Stack direction="row" sx={{ position: 'absolute', left: 0, top: 0, height: '100%' }}>
        <Box sx={{ width: '12px', position: 'relative' }}>
          <Box sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            height: '10px',
            width: 0,
            borderLeft: `solid 1px ${theme.palette.border.primary}`,
          }} />

          <Box sx={{
            position: 'absolute',
            left: 0,
            top: '10px',
            width: '12px',
            height: 0,
            borderTop: `solid 1px ${theme.palette.border.primary}`,
            borderTopLeftRadius: 6,
          }} />

          {!isLast && (
            <Box sx={{
              position: 'absolute',
              left: 0,
              top: '10px',
              bottom: 0,
              width: 0,
              borderLeft: `solid 1px ${theme.palette.border.primary}`,
            }} />
          )}
        </Box>
      </Stack>

      <Typography
        sx={{
          fontSize: 10,
          color: theme.palette.text.secondary,
          py: 0.5
        }}
      >
        {getActionLabel(routingKey || action, t)} - {getAttributeLabel(diff.attribute, t)}
      </Typography>

      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}>
        <Box
          sx={{
            textDecoration: 'line-through',
            color: theme.palette.text.primary,
            fontSize: 11
          }}
        >
          {formatDiffValue(diff.old_value, t) || <em>{t('auth.history.not_provided', 'Non renseigné')}</em>}
        </Box>
        <i className="fa-light fa-arrow-right" style={{ color: theme.palette.text.secondary, fontSize: 10 }} />
        <Typography sx={{ fontSize: 11, color: theme.palette.text.primary }}>
          {formatDiffValue(diff.new_value, t) || <em>{t('auth.history.not_provided', 'Non renseigné')}</em>}
        </Typography>
      </Box>
    </Box>
  )
}

export default HistoryItemDiff
